import React, { useState, useEffect } from "react";
import { toastMsg } from "../../functions/toastMsg";
import { deleteDataToken, getData, patchDataToken, postData } from "../../axios/axiosHelper";
import bannerIcon from "../../assets/icons/mediaIcons/banner 1.png";
import { ADMIN_PAGE_LABELS } from "../../navigation/adminNavigation";

const BannerHooks = () => {
  
  const [loadingAddBanner, setLoadingAddBanner] = useState(false);

  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [banners, setBanners] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 10;
  const [show, setShow] = useState(false);
  const [image, setImage] = useState(null);
  const [link, setLink] = useState("");
  const [search, setSearch] = useState("");
  const [deleteBannerLoading, setDeleteBannerLoading] = useState({});
  const [forUser, setForUser] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    resetForm();
  };

  const resetForm = () => {
    setLink("");
    setImage(null);
    setEditMode(false);
    setSelectedBanner(null);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];

      setImage(file);

  };

  const handleLinkChange = (event) => {
    setLink(event.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoadingAddBanner(true);
    const formData = new FormData();
    image && formData.append("image" , image)
    formData.append("link", link);
    formData.append("forUser", forUser); 
    setLoading(true);

    const apiCall = editMode
      ? patchDataToken(`/banner/${selectedBanner._id}`, formData, true)
      : postData("/banner", formData, true);

    apiCall
      .then((res) => {
        const updatedBanners = editMode
          ? banners.map((b) => (b._id === selectedBanner._id ? res.data.data : b))
          : [...banners, res.data.data];

        setBanners(updatedBanners);
        handleClose();
        toastMsg(res.data?.message, "success");
      })
      .catch((err) => toastMsg(err.response.data.message, "error"))
      .finally(() => {
        setLoading(false);
    setLoadingAddBanner(false);

      });
  };

  useEffect(() => {
    setLoading(true);
    let queryParams = `/banner?page=${currentPage}&perPage=${perPage}`;

    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`;
    }

    getData(queryParams, true)
      .then((res) => {
        setBanners(res.data.data);
        setTotalPages(res.data.pagination.totalPages);
      })
      .catch((err) => toastMsg(err.response.data.message, "error"))
      .finally(() => setLoading(false));
  }, [currentPage, perPage, search]);

  const handleDelete = (bannerId) => {
    setDeleteBannerLoading((prevState) => ({ ...prevState, [bannerId]: true }));
  
    deleteDataToken(`/banner/${bannerId}`, true)
      .then((res) => {
        toastMsg(res.data?.message, "success");
        setBanners((prev) => prev.filter((pr) => pr._id !== bannerId));
      })
      .catch((err) => {
        toastMsg(err.response?.data?.message || "An error occurred", "error");
      })
      .finally(() => {
        setDeleteBannerLoading((prevState) => ({ ...prevState, [bannerId]: false }));
      });
  };
  const [imageForEdit, setImageForEdit] = useState(false)
  
  const handleEdit = (banner) => {
    setEditMode(true);
    setSelectedBanner(banner);
    setLink(banner.link); // Set the existing link
    setImageForEdit(banner?.image)
    handleShow(); // Show the offcanvas
  };

  return {
    NavItems: [
      {
        name: ADMIN_PAGE_LABELS.appBanners,
        to: "/media/banner",
        icon: bannerIcon,
      },
    ],
    setSearch,
    handleShow,
    show,
    handleClose,
    handleImageChange,
    handleLinkChange,
    link,
    handleSubmit,
    loading,
    banners,
    handleDelete,
    handleEdit,
    editMode,
    loadingAddBanner,
    deleteBannerLoading,
    imageForEdit,
    forUser,
     setForUser
  };
};

export default BannerHooks;
